module.exports = __webpack_public_path__ + "img/cashback.557aa4e2.png";